import { render, staticRenderFns } from "./currentFilter.vue?vue&type=template&id=5cf56a2e&scoped=true"
import script from "./currentFilter.vue?vue&type=script&lang=js"
export * from "./currentFilter.vue?vue&type=script&lang=js"
import style0 from "./currentFilter.vue?vue&type=style&index=0&id=5cf56a2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf56a2e",
  null
  
)

export default component.exports